import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class AppLoginConfigQueryCriteriaClass extends BaseCriteriaModel {
  app_login_guid?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  revision?: Optional<string> = Optional.empty();
}

export class AppLoginConfigCriteriaModelQuery {
  query = '';

  constructor(appLoginConfigCriteriaModel: AppLoginConfigQueryCriteriaClass) {

    if (!appLoginConfigCriteriaModel) {
      return;
    }

    this.query += appLoginConfigCriteriaModel.app_login_guid.filter(x => x !== '').map(x => '&app_login_guid=' + x).orElse('');
    this.query += appLoginConfigCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += appLoginConfigCriteriaModel.revision.filter(x => x !== '').map(x => '&revision=' + x).orElse('');

    this.query += '&status=' + appLoginConfigCriteriaModel.status;
    this.query += '&orderBy=' + appLoginConfigCriteriaModel.orderBy;
    this.query += '&order=' + appLoginConfigCriteriaModel.order;
    this.query += '&offset=' + appLoginConfigCriteriaModel.offset + '&limit=' + appLoginConfigCriteriaModel.limit;
  }
}
